export class BiometryFingerPrintCaptureRequest {
    codeSecurity: string;
    device: string;

    constructor(codeSecurity: string, device: string) {
        this.codeSecurity = codeSecurity;
        this.device = device;
    }
}